<template>
  <nav class="navbar">
    <div class="navbar-container">
      <div class="logo">
        <img src="../assets/logo.png" alt="GCI Logo" class="logo-img">
        <h1 class="site-title">Go Coin Identifier</h1>
      </div>
      <div class="nav-links">
        <a href="#" class="active">Home</a>
        <a href="#features">Features</a>
        <a href="#tech">Technology</a>
        <a href="#use-cases">Use Cases</a>
        <a href="mailto:sl9283191@gmail.com">Contact Us</a>
      </div>
      <div class="mobile-menu-btn" :class="{ 'active': mobileMenuOpen }" @click="toggleMobileMenu">
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
      </div>
    </div>
    <div class="mobile-nav" :class="{ 'active': mobileMenuOpen }">
      <a href="#" class="active" @click="closeMenu">
        <span class="nav-icon">🏠</span>
        <span>Home</span>
      </a>
      <a href="#features" @click="closeMenu">
        <span class="nav-icon">✨</span>
        <span>Features</span>
      </a>
      <a href="#tech" @click="closeMenu">
        <span class="nav-icon">🔍</span>
        <span>Technology</span>
      </a>
      <a href="#use-cases" @click="closeMenu">
        <span class="nav-icon">📱</span>
        <span>Use Cases</span>
      </a>
      <a href="mailto:sl9283191@gmail.com" @click="closeMenu">
        <span class="nav-icon">✉️</span>
        <span>Contact Us</span>
      </a>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      mobileMenuOpen: false
    }
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      document.body.style.overflow = this.mobileMenuOpen ? 'hidden' : '';
    },
    closeMenu() {
      this.mobileMenuOpen = false;
      document.body.style.overflow = '';
    }
  }
}
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #212129;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}

.navbar-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 25px;
  height: 100px;
  max-width: 1800px;
  margin: 0 auto;
}

.logo {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  max-width: 70%;
  margin-left: 200px;
}

.logo-img {
  height: 80px;
  width: auto;
  margin-right: 20px;
  transition: transform 0.3s;
}

.logo-img:hover {
  transform: scale(1.05);
}

.site-title {
  color: #ffd700;
  font-size: 36px;
  font-weight: 700;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nav-links {
  display: flex;
  margin-right: 150px;
  margin-left: auto;
}

.nav-links a {
  color: #fff;
  text-decoration: none;
  margin-left: 45px;
  font-size: 20px;
  position: relative;
  padding: 5px 0;
  transition: all 0.3s;
}

.nav-links a::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #ffd700;
  transition: width 0.3s;
}

.nav-links a:hover {
  color: #ffd700;
}

.nav-links a:hover::after, 
.nav-links a.active::after {
  width: 100%;
}

.nav-links a.active {
  color: #ffd700;
}

.mobile-menu-btn {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 20px;
  cursor: pointer;
  z-index: 1010;
  margin-right: 0;
}

.bar {
  height: 3px;
  width: 100%;
  background-color: #fff;
  border-radius: 3px;
  transition: all 0.3s;
}

.mobile-nav {
  display: none;
  flex-direction: column;
  background-color: #19191f;
  padding: 20px;
  transform: translateY(-100%);
  transition: all 0.3s ease-in-out;
  position: fixed;
  top: 90px;
  left: 0;
  right: 0;
  width: 100%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  z-index: 990;
  border-bottom: 3px solid #ffd700;
}

.mobile-nav.active {
  transform: translateY(0);
  opacity: 1;
}

.mobile-nav a {
  color: #fff;
  text-decoration: none;
  padding: 15px 10px;
  font-size: 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  border-radius: 8px;
  margin-bottom: 5px;
}

.nav-icon {
  margin-right: 15px;
  font-size: 20px;
  background: linear-gradient(135deg, #111855, #ffd700);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}

.mobile-nav a.active {
  color: #ffd700;
  background-color: rgba(255, 215, 0, 0.15);
  border-radius: 8px;
  border-bottom: none;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.mobile-nav a:hover {
  color: #ffd700;
  background-color: rgba(255, 215, 0, 0.1);
  border-radius: 8px;
  transform: translateX(5px);
}

@media (max-width: 768px) {
  .navbar-container {
    padding: 0 15px;
    height: 90px;
    justify-content: space-between;
  }
  
  .logo {
    max-width: 70%;
    flex-shrink: 1;
    margin-left: 0;
  }
  
  .nav-links {
    display: none;
  }
  
  .mobile-menu-btn {
    display: flex;
    margin-right: 0;
    margin-left: 10px;
    position: relative;
    right: 0;
    flex-shrink: 0;
  }
  
  .site-title {
    font-size: 28px;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1;
    font-weight: 700;
  }
  
  .logo-img {
    height: 65px;
    margin-right: 15px;
    min-width: 65px;
  }
  
  .mobile-nav {
    display: flex;
    opacity: 0;
    max-height: calc(100vh - 90px);
    overflow-y: auto;
    top: 90px;
    padding: 20px 25px;
  }
  
  .mobile-menu-btn.active .bar:nth-child(1) {
    transform: rotate(45deg) translate(5px, 5px);
  }
  
  .mobile-menu-btn.active .bar:nth-child(2) {
    opacity: 0;
  }
  
  .mobile-menu-btn.active .bar:nth-child(3) {
    transform: rotate(-45deg) translate(7px, -6px);
  }
  
  .mobile-nav a {
    padding: 12px 10px;
    font-size: 16px;
    margin-bottom: 4px;
  }
  
  .nav-icon {
    margin-right: 12px;
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .navbar-container {
    padding: 0 10px;
    height: 80px;
  }
  
  .logo {
    max-width: 75%;
  }
  
  .site-title {
    font-size: 22px;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1;
    font-weight: 700;
  }
  
  .logo-img {
    height: 50px;
    margin-right: 10px;
    min-width: 50px;
  }
  
  .mobile-menu-btn {
    padding: 8px;
    margin-right: 0;
    margin-left: 5px;
    position: relative;
    right: 0;
  }
  
  .mobile-nav a {
    padding: 10px 12px;
    font-size: 15px;
    margin-bottom: 3px;
  }
  
  .nav-icon {
    margin-right: 10px;
    font-size: 16px;
  }
  
  .mobile-nav {
    top: 80px;
    max-height: calc(100vh - 80px);
    padding: 15px 20px;
  }
}
</style> 